import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-jan-hamernik",
  name: `Jan Hamernik Acceptance Letter\n(Custom Letter)`,
  nameFormatted: {
    primary: "Jan Hamernik Acceptance Letter",
    secondary: "(Custom Letter)",
  },
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
